import {
  GROUPING_HISTORY_FAILED,
  GROUPING_HISTORY_REQUEST,
  GROUPING_HISTORY_SUCCESS,
} from "app/redux/actions/Factory/Grouping/groupingHistory/constant";

const INIT_STATE = {
  loading: false,
  totalPage: 0,
  data: [],
  error: {
    isError: false,
    message: null,
  },
};

export const groupingHistoryReducer = function (state = INIT_STATE, action) {
  switch (action?.type) {
    case GROUPING_HISTORY_REQUEST:
      return {
        loading: true,
        totalPage: 0,
        data: [],
        error: {
          isError: false,
          message: null,
        },
      };
    case GROUPING_HISTORY_SUCCESS:
      return {
        loading: false,
        data: action?.payload?.data,
        totalPage: action?.payload?.totalPage,
        error: {
          isError: false,
          message: null,
        },
      };
    case GROUPING_HISTORY_FAILED:
      const { isError = true, message = "Something Went Wrong" } =
        action?.payload?.error || {};
      return {
        loading: false,
        totalPage: 0,
        data: [],
        error: {
          isError: isError,
          message: message,
        },
      };
    default:
      return state;
  }
};
